const scrollbarContextKey = Symbol("scrollbarContextKey");

export { scrollbarContextKey };
//# sourceMappingURL=scrollbar.mjs.map
